module.exports = Em.Handlebars.compile("<div {{bind-attr class=creditCardType.class}}>\n    {{svgb creditCardType.path}}\n</div>\n");